import React, { useState, useEffect } from 'react'
import { Input } from 'reactstrap'
import '../../quoter/styleQuoters/styleSidebarQuoter.css'


export const IndexSidebarQuoter = (props) => {


    const {
        itemsTree, viewQuoter,
        observations,
        handleInputChange


    } = props;
    // console.log("🚀 treeviewRef", treeviewRef);
    // console.log("🍋 itemsTree", itemsTree);

    // ! SCROLL
    const [openExam, setOpenExam] = useState([]);


    useEffect(() => {
        if (itemsTree?.length > 0) {

            const openItems = itemsTree
                .map((exam, index) => {

                    const hasPatientIndications =
                        exam.children?.[0]?.children?.some(
                            item => item.text !== "Sin indicaciones de paciente"
                        );

                    const hasLabIndications =
                        exam.children?.[1]?.children?.some(
                            item => item.text !== "Sin indicaciones de laboratorio"
                        );

                    return hasPatientIndications || hasLabIndications
                        ? index
                        : null;
                })
                .filter(index => index !== null);

            setOpenExam(openItems);

        } else {
            setOpenExam([]);
        }
    }, [itemsTree]);

    const toggleExam = (index) => {
        setOpenExam(prev => {
            if (prev.includes(index)) {
                // cerrar únicamente este
                return prev.filter(i => i !== index);
            }

            // abrir sin cerrar los demás
            return [...prev, index];
        });
    };
    const [expandedText, setExpandedText] = useState({});

    const toggleText = (key) => {
        setExpandedText(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };



    // console.log("itemsTree", itemsTree);
    // console.log("itemsTree.length", itemsTree?.length);
    return (
        <>
            <div className={`sidebar-container-quoter-clinics ${viewQuoter ? "sidebar-disabled" : ""}`}>


                {
                    //* INFROMATION GENERAL
                }
                <div className="sidebar-information-card">

                    <div className="sidebar-information-header">
                        <div className="sidebar-information-icon">
                            <i className="fa fa-commenting-o"></i>
                        </div>

                        <div>
                            <h6>Observaciones</h6>
                            <span>Notas adicionales para la cotización</span>
                        </div>
                    </div>

                    <div className="observation-wrapper">
                        <Input
                            type="textarea"
                            rows="2"
                            name="observations"
                            placeholder="Escribe aquí observaciones importantes..."
                            className="observation-textarea"
                            value={observations}
                            onChange={handleInputChange}


                        />
                    </div>

                </div>

                {
                    //* INDICATIOSN EXAMS AND PROFILES
                }

                <br />

                <div className="p-l-0">

                    <div className="section-header mb-2">
                        <i className="fa fa-list-ul mr-2"></i>
                        <span>Indicaciones</span>
                    </div>

                    <div className="custom-tree">

                        {itemsTree && itemsTree.length > 0 ? (

                            itemsTree.map((exam, index) => (

                                <div
                                    key={index}
                                    className="instruction-card"
                                >

                                    {/* HEADER DEL ESTUDIO */}

                                    <div
                                        className="instruction-card-header"
                                        onClick={() => toggleExam(index)}
                                    >
                                        <div className="instruction-card-info">
                                            <div
                                                className="instruction-card-title"
                                                title={exam.text}
                                            >
                                                {exam.text}
                                            </div>
                                        </div>

                                        <div className="instruction-collapse-icon">
                                            <i
                                                className={`fa ${openExam.includes(index)
                                                    ? "fa-chevron-up"
                                                    : "fa-chevron-down"
                                                    }`}
                                            />
                                        </div>
                                    </div>



                                    {/* CONTENIDO */}

                                    <div
                                        className={`instruction-content ${openExam.includes(index)
                                            ? "expanded"
                                            : "collapsed"
                                            }`}
                                    >

                                        {exam.children?.map((group, g) => {

                                            const patient =
                                                group.text
                                                    ?.toLowerCase()
                                                    .includes("paciente");

                                            return (

                                                <div
                                                    key={g}
                                                    className="instruction-section"
                                                >

                                                    {/* TIPO */}

                                                    <div
                                                        className={
                                                            patient
                                                                ? "instruction-section-title-particular"
                                                                : "instruction-section-title-lab"
                                                        }
                                                    >
                                                        <span>
                                                            {patient ? "Paciente" : "Laboratorio"}
                                                        </span>
                                                    </div>

                                                    {/* LISTA */}

                                                    {group.children?.map((item, i) => {

                                                        const key = `${index}-${g}-${i}`;

                                                        return (

                                                            <div
                                                                key={key}
                                                                className={
                                                                    patient
                                                                        ? "instruction-item instruction-item-patient"
                                                                        : "instruction-item instruction-item-lab"
                                                                }
                                                            >

                                                                <i className="fa fa-circle" />

                                                                <span

                                                                    title={item.text}

                                                                    onClick={() => toggleText(key)}

                                                                    className={
                                                                        expandedText[key]
                                                                            ? "instruction-text expanded"
                                                                            : "instruction-text"
                                                                    }

                                                                >

                                                                    {item.text}

                                                                </span>

                                                            </div>

                                                        );

                                                    })}

                                                </div>

                                            );

                                        })}

                                    </div>

                                </div>

                            ))

                        ) : (

                            <div className="instruction-empty">

                                <i className="fa fa-info-circle" />

                                <div>

                                    No existen indicaciones para los estudios seleccionados.

                                </div>

                            </div>

                        )}

                    </div>

                </div>
            </div>

        </>
    )
}
